import { TokenWrapper } from '../../util/TokenWrapper';
import { Notification, NotificationStore, NotificationType } from '../NotificationStore';
import { GoFeralAuthClient } from '../../clients/GoFeralAuthClient';
import { AuthCodes } from '@foxbun/lib-goferal-types';
import { ObjectId } from 'bson';
import { RouteError, StandardErrorCodes } from '@foxbun/lib-errors';

export interface GoFeralTokenWrapperOptions {
  refresh_token: () => string;
  set_refresh_token: (token: string) => void;
  logout: () => any;
  auth_client: GoFeralAuthClient;
  notification_store: NotificationStore;
  profile_id: ObjectId;
}

export class GoFeralTokenWrapper extends TokenWrapper {
  constructor(options: GoFeralTokenWrapperOptions) {
    super(async () => {
      try {
        let res = await options.auth_client.accessToken(options.refresh_token(), {
          profile_id: options.profile_id
        });
        options.set_refresh_token(res.refresh_token);
        return res.token;
      } catch (ex) {
        if (ex instanceof RouteError) {
          if (ex.error.code === AuthCodes.MAINTENANCE_MODE) {
            options.notification_store.showNotification(
              new Notification({
                type: NotificationType.ERROR,
                desc: 'We are entering maintenance mode! Please check our socials for more information.'
              })
            );
            options.logout();
          }
          if (ex.error.code === StandardErrorCodes.AUTHENTICATION_FAILED) {
            options.notification_store.showNotification(
              new Notification({
                type: NotificationType.ERROR,
                desc: 'Session expired, please sign in again.'
              })
            );
            options.logout();
          }
        }
        throw ex;
      }
    });
  }
}
